/**
 * Image card slider – class-based web component, Swiper with coverflow effect.
 * Uses <custom-image-card-slider> and .custom-image-card-slider-* classes.
 */
(function () {
  class CustomImageCardSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    init() {
      if (typeof window.Swiper === 'undefined' || this.swiper) return;

      const sliderEl = this.querySelector('.custom-image-card-slider__slider');
      if (!sliderEl) return;

      const prevEl = sliderEl.querySelector('.swiper-button-prev');
      const nextEl = sliderEl.querySelector('.swiper-button-next');
      const paginationEl = this.querySelector('.custom-image-card-slider__pagination');
      const autoplay = this.dataset.autoplay === 'true';
      const autoplaySpeed = parseInt(this.dataset.autoplaySpeed || '5000', 10);

      const config = {
        effect: "coverflow",
        centeredSlides: true,
        speed: 600,
        // loopAdditionalSlides: 4,
        // loopedSlides: 4,
        loop: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 9,
          stretch: 0,
          depth: 200,
          modifier: 1,
          slideShadows: false
        },
        initialSlide: 1,
        breakpoints: {
          320: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 2
          },
          1024: {
            slidesPerView: 3
          }
        },
        wrapperClass: 'custom-image-card-slider__wrapper',
        slideClass: 'custom-image-card-slider__slide',
        navigation:
          prevEl && nextEl
            ? { nextEl: nextEl, prevEl: prevEl }
            : false,
        pagination: paginationEl
          ? { el: paginationEl, clickable: true }
          : false,
      };

      if (autoplay && autoplaySpeed > 0) {
        config.autoplay = { delay: autoplaySpeed, disableOnInteraction: false };
      }

      this.swiper = new window.Swiper(sliderEl, config);
    }

    connectedCallback() {
      if (typeof window.Swiper !== 'undefined') {
        this.init();
        return;
      }
      const onSwiper = () => {
        window.removeEventListener('load', onSwiper);
        if (typeof window.Swiper !== 'undefined') this.init();
      };
      window.addEventListener('load', onSwiper);
    }

    disconnectedCallback() {
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  if (!customElements.get('custom-image-card-slider')) {
    customElements.define('custom-image-card-slider', CustomImageCardSlider);
  }
})();
